import React, { useEffect } from 'react';
import {
  useGetUserInfoQuery,
  useAddPointMutation,
  useGetBalanceQuery,
} from 'services';
import { InputText, Loading } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { PopupWraper } from '../../../components/popup';
import { AddPointSuccess, AddPointSuccessDefined } from './configs';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';

interface AddPointProps {
  userId: string;
  onClose: () => void;
  forceUpdateTable: () => void;
}
const AddPoint = ({ userId, onClose, forceUpdateTable }: AddPointProps) => {
  const { refetch: refetchBalance } = useGetBalanceQuery();
  const { mutateAsync, data, error } = useAddPointMutation();
  const { data: userInfo, isFetching: isFetchungUserInfo } =
    useGetUserInfoQuery({ userId });
  const { phoneNumber, fullName, balance } = userInfo?.data || {
    phoneNumber: '',
    fullName: '',
    balance: '',
  };

  const nomorlizeBalance = (balance: number) => {
    return Number(balance).toLocaleString('en-US');
  };

  const { handleSubmit, getInputProps } = useForm({
    structure: [
      {
        name: 'amount',
        label: '',
        validate: Yup.number()
          .required('Vui lòng nhập số điểm')
          .typeError('Vui lòng nhập số'),
      },
    ],
    onSubmit: async (values) => {
      const payload = {
        toUserId: userId,
        amount: Number(values.amount),
        reason: '',
      };

      try {
        await mutateAsync(payload);
        refetchBalance();
      } catch (error) {
        console.log('error', error);
      }
      forceUpdateTable();
      onClose();
    },
  });

  useEffect(() => {
    if (data) {
      const { statusCode } = data;

      const dataDefined = AddPointSuccessDefined[statusCode as AddPointSuccess];

      if (statusCode === 200) {
        toast.success(dataDefined?.message, { duration: 1500 });
      }
    }

    // if (error) {
    //   const { status } = error as Error;
    //   toast.error(AddPointErrorDefined[(status as AddPointError) || 500]?.message);
    // }
  }, [data, error]);

  if (isFetchungUserInfo) {
    return <Loading isLoading={isFetchungUserInfo} />;
  } else {
    return (
      <div className='wrap-pop-up-add-point'>
        <PopupWraper title='Thêm điểm' onClose={onClose}>
          <div className='container-fluid add-points__user-info'>
            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Tài khoản</div>
              <div className='col-md-4 col-12'>
                {normalizedPhoneNumber(phoneNumber || '')}
              </div>
            </div>

            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Tên tài khoản</div>
              <div className='col-md-4 col-12'>{fullName}</div>
            </div>

            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Số dư</div>
              <div className='col-md-4 col-12'>{`${nomorlizeBalance(Number(balance))} đ`}</div>
            </div>
          </div>

          <div className='container-fluid add-points__form-add-point'>
            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Số điểm</div>
              <div className='col-md-4 col-12'>
                <InputWraper
                  inputProps={getInputProps('amount')}
                  renderInput={(props) => {
                    return <InputText {...props} placeholder='Nhập số điểm' />;
                  }}
                />
              </div>
            </div>

            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Số dư sau khi thêm</div>
              <div className='col-md-4 col-12'>
                {balance
                  ? nomorlizeBalance(
                      Number(balance) + Number(getInputProps('amount').value),
                    )
                  : nomorlizeBalance(
                      Number(getInputProps('amount').value),
                    )}{' '}
                đ
              </div>
            </div>
          </div>
          <div className='add-points__button-add-point'>
            <Button
              buttonType='success'
              onClick={handleSubmit}
              label={'Thêm điểm'}
            />
            <Button
              label='Trở về'
              buttonType='grey'
              onClick={() => onClose()}
            />
          </div>
        </PopupWraper>
      </div>
    );
  }
};

export default AddPoint;
